export default {
  "recommend.contents.title": "Related Articles",
  "recommend.event.title": "Recommended Events",
};
